<template>
  <q-card flat :style="!$q.screen.lt.md && !standalone?'width: 500px; max-width: 100vw;':''">
    <q-card-section class="no-padding">
      <q-banner v-if="isDialog" class="bg-blue text-white" inline-actions>
        ارسال پیامک
        <template v-slot:action>
          <q-btn round flat icon="close" v-close-popup/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section v-if="!standalone">
      <span class="text-bold"
            v-if="(customer || customer!=='') && !share && !multiple">ارسال پیامک به {{ customer.Cs_Name }}</span>
      <span class="text-bold" v-if="(customer || customer!=='') && share && !multiple">به اشتراک گذاری اطلاعات {{
          customer.Cs_Name
        }}</span>
      <span class="text-subtitle2" v-if="multiple && customers && customers.length>0">ارسال برای {{
          customers.filter(item => item.CsSpe_ID === 2 && item.Cs_Mobile && item.Cs_Mobile.length === 11).length + 1
        }} طرف معامله</span>
    </q-card-section>
    <q-form autofocus greedy @submit="onSubmit">
      <q-card-section class="no-padding">
        <q-input
            :autofocus="share"
            :disable="!share && !standalone"
            :dense="$q.screen.lt.md"
            class="q-ma-sm"
            filled
            dir="ltr"
            v-model="customerPhone"
            type="tel"
            v-if="!multiple"
            mask="###########"
            hide-bottom-space
            :rules="[val => !!val || 'الزامی است']"
            label="شماره تماس">
          <template v-slot:prepend>
            <q-icon name="phone_android"/>
          </template>
        </q-input>
        <q-input filled v-model="scheduledPersian"
                 :disable="lockSchedule"
                 class="q-ma-sm"
                 dir="ltr"
                 label="زمانبندی ارسال پیامک"
                 clearable
                 @clear="scheduled=undefined;scheduledPersian=undefined"
                 alendar="persian">
          <template v-slot:prepend>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy transition-show="scale" transition-hide="scale">
                <q-date v-model="scheduled" mask="YYYY-MM-DD HH:mm" calendar="persian">
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="بستن" color="primary" flat/>
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>

          <template v-slot:after>
            <q-input v-model="scheduledTime" type="time"

                     clearable class="q-mb-xs"/>
          </template>
        </q-input>
        <q-input
            :dense="$q.screen.lt.md"
            :autofocus="!share"
            :disable="share"
            class="q-ma-sm"
            filled
            v-model="messageBody"
            hide-bottom-space
            type="textarea"
            label="متن پیامک خود را اینجا وارد نمایید"
            lazy-rules
            :rules="[ val => val && val.length > 15 || 'متن پیامک الزامی است']">
        </q-input>
      </q-card-section>
      <q-card-section class="no-padding">
        <q-toggle v-model="whatsApp" label="ارسال از طریق WhatsApp"/>
      </q-card-section>
      <q-card-section class="text-right q-pa-xs">
        <q-btn label="ارسال پیامک" type="submit"
               class="bg-indigo-6 text-white" icon="email"/>
        <q-btn label="انصراف" flat class="q-ml-sm" icon="cancel" color="red" v-close-popup/>
      </q-card-section>
    </q-form>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";


export default {
  name: "SMSPanel",
  props: {
    customer: {
      type: Object,
      default: () => {
      }
    },
    share: {
      type: Boolean
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false,
    },
    customers: {
      type: Array,
      default: () => [],
      required: false,
    },
    standalone: {
      type: Boolean,
      default: () => false
    },
    isDialog: {
      type: Boolean,
      default: () => false
    },
    defaultMessage: {
      type: String,
      default: () => undefined
    },
    receiveBuCurrentUser: {
      type: Boolean,
      default: () => false
    },
    withCustomerInfo: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      messageBody: '',
      customerPhone: '',
      scheduled: undefined,
      scheduledTime: undefined,
      scheduledPersian: undefined,
      whatsApp: false,
      lockSchedule: false
    }
  },
  methods: {
    ...mapActions({
      SendSMS: 'send_sms_by_user',
      sendBatch: 'sendBatchSNS'
    }),
    onSubmit() {
      if (this.multiple) {
        this.sendBatch(
            {
              customers: this.customers.filter(item => item.Cs_Mobile && item.Cs_Mobile.length === 11),
              message: this.messageBody,
              scheduled: this.ToGregorianDateTimeFormat(this.scheduledPersian),
              whatsapp: this.whatsApp
            }).then(() => {
          this.$q.notify({
            type: 'positive',
            color: 'positive',
            message: 'پیامک ارسال گردید',
            position: 'top'
          })
          this.$emit('sms_sended')
        })
      } else {
        this.SendSMS({
          phoneNo: !this.share && !this.standalone ? this.customer.Cs_Mobile : this.customerPhone,
          Message: this.messageBody,
          scheduled: this.ToGregorianDateTimeFormat(this.scheduledPersian),
          whatsapp: this.whatsApp
        }).then(() => {
          this.$q.notify({
            type: 'positive',
            color: 'positive',
            message: 'پیامک ارسال گردید',
            position: 'top'
          })
          this.cleanData()
          this.$emit('sms_sended')
        }).catch(() => {
          this.$q.notify({
            type: 'negative',
            color: 'negative',
            message: 'پیامک ارسال نگردید',
            position: 'top'
          })
        })
      }
    },
    cleanData() {
      this.messageBody = undefined
      this.customerPhone = undefined
      this.scheduled = undefined
      this.scheduledPersian = undefined
      this.scheduledTime = undefined
      this.whatsApp = false
      if (this.isDialog) {
        this.$emit('close-dialog')
      }
    }
  },
  watch: {
    scheduled: function () {
      this.scheduledPersian = `${this.scheduled || this.getTodayDateJalali()} ${this.scheduledTime || "00:00"}`
    },
    scheduledTime: function () {
      this.scheduledPersian = `${this.scheduled || this.getTodayDateJalali()} ${this.scheduledTime || "00:00"}`
    },
    whatsApp: function () {
      this.lockSchedule = this.whatsApp
    }
  },
  created() {
    if (!this.standalone) {
      if (!this.multiple) {
        if (!this.share) {
          this.customerPhone = this.customer.Cs_Mobile
        } else {
          this.messageBody = 'نام و نام خانوادگی: ' + this.customer.Cs_FirName + ' ' + this.customer.Cs_FamName + '\n' + 'شماره تماس: ' + this.customer.Cs_Mobile
              + '\n' + 'آدرس: ' + this.customer.Cs_Address1 + '\n' +
              (this.customer.latitude !== null && this.customer.longitude !== null ? 'موقعیت بر روی نقشه: ' + '\n' +
                  `https://maps.google.com/?q=${this.customer.latitude},${this.customer.longitude}` : '');
        }
      }
    }

    if (this.defaultMessage !== undefined) {
      if (this.withCustomerInfo) {
        if (this.customer) {
          this.messageBody = `نام طرف معامله: ${this.customer.Cs_Name}\n شناسه: ${this.customer.Cs_Code}\nزمان ارسال گزارش: ${this.getTodayDateJalaliFull()}\n\n${this.defaultMessage}`
        } else {
          this.messageBody = this.defaultMessage
        }
      } else {
        this.messageBody = this.defaultMessage
      }
    }

    if (this.receiveBuCurrentUser) {
      this.customerPhone = this.$store.state.userMobile
    }
  }
}
</script>

<style scoped>

</style>
